export const MEDIA_CONIDTION_SIZES_LAPTOP_ONLY =
    '((min-width: 1024px) and (max-width: 1920px))';
export const MEDIA_CONIDTION_SIZES_LARGE_SCREEN = '(min-width: 1921px)';
export const GLOBAL_WIDTH_SIZE_DESKTOP = 1920;
export const GLOBAL_WIDTH_SIZE_MOBILE = 414;
